import {  getElementFromSelectorWithOffsetHeight } from '../assets/utils.js'

const detectMob = () => {
  return window.innerWidth < 750
}

const FAQ_HEADER_SELECTOR = '[data-faq-heading-text]'

// Utility functions
const createListItem = () => {
    const li = document.createElement('div')
    li.classList.add('faq-navigator-tab-container')
    return li
  }
  
  const createAnchor = (title, clickHandler) => {
    const anchor = document.createElement('a')
    anchor.setAttribute('href', '')
    anchor.setAttribute('aria-label', 'scroll To FAQ')
    anchor.setAttribute('data-navigator-anchor', '')
    anchor.classList.add('faq-navigator-tab')
    anchor.addEventListener('click', clickHandler)
    return anchor
  }
  
  const createSpan = title => {
    const span = document.createElement('span')
    span.textContent = title
    span.classList.add('faq-navigator-tab-text')
    return span
  }
  
  const appendElements = (li, anchor, span, container) => {
    anchor.appendChild(span)
    li.appendChild(anchor)
    container.appendChild(li)
  }
  
  // Main class
  class FaqNavigator extends HTMLElement {
    constructor() {
      super()
      this.faqTabContainer = this.querySelector('[data-faq-navigator-tab-container]')
      this.faqSections = document.querySelectorAll('[data-scroll-to-this-faq]')
      this.headerElements = Array.from(document.querySelectorAll(FAQ_HEADER_SELECTOR))
      this.init()
    }
  
    handleFaqClick = event => {
      event.preventDefault()
      const { target } = event || {}
      const text = target.innerText
      const faqHeader = this.headerElements.find(header => header.innerText.toLowerCase() === text.toLowerCase())
      if (!faqHeader) return
      const headerHeight = getElementFromSelectorWithOffsetHeight('.header').offsetHeight
      const promoBarHeight = detectMob() ? getElementFromSelectorWithOffsetHeight('.utility-bar').offsetHeight : 0
      const rect = faqHeader.getBoundingClientRect()

      const offsetTop = window.scrollY + rect.top - headerHeight - promoBarHeight
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      })
    }
  
    generateFaqTab = faqElement => {
      const faqHeading = faqElement.querySelector(FAQ_HEADER_SELECTOR)
      const title = faqHeading.innerText
      const li = createListItem()
      const anchor = createAnchor(title, this.handleFaqClick)
      const span = createSpan(title)
      appendElements(li, anchor, span, this.faqTabContainer)
    }
  
    init = () => {
      if (!this.faqTabContainer) return
      this.faqSections.forEach(faq => this.generateFaqTab(faq))
      // Implement a tab system here if needed.
    }
  }
  
  customElements.define('faq-navigator', FaqNavigator)